var _a;
/**
 * @hidden
 */
export var filterClearButton = 'treelist.filterClearButton';
/**
 * @hidden
 */
export var filterEqOperator = 'treelist.filterEqOperator';
/**
 * @hidden
 */
export var filterNotEqOperator = 'treelist.filterNotEqOperator';
/**
 * @hidden
 */
export var filterIsNullOperator = 'treelist.filterIsNullOperator';
/**
 * @hidden
 */
export var filterIsNotNullOperator = 'treelist.filterIsNotNullOperator';
/**
 * @hidden
 */
export var filterIsEmptyOperator = 'treelist.filterIsEmptyOperator';
/**
 * @hidden
 */
export var filterIsNotEmptyOperator = 'treelist.filterIsNotEmptyOperator';
/**
 * @hidden
 */
export var filterStartsWithOperator = 'treelist.filterStartsWithOperator';
/**
 * @hidden
 */
export var filterContainsOperator = 'treelist.filterContainsOperator';
/**
 * @hidden
 */
export var filterNotContainsOperator = 'treelist.filterNotContainsOperator';
/**
 * @hidden
 */
export var filterEndsWithOperator = 'treelist.filterEndsWithOperator';
/**
 * @hidden
 */
export var filterGteOperator = 'treelist.filterGteOperator';
/**
 * @hidden
 */
export var filterGtOperator = 'treelist.filterGtOperator';
/**
 * @hidden
 */
export var filterLteOperator = 'treelist.filterLteOperator';
/**
 * @hidden
 */
export var filterLtOperator = 'treelist.filterLtOperator';
/**
 * @hidden
 */
export var filterIsTrue = 'treelist.filterIsTrue';
/**
 * @hidden
 */
export var filterIsFalse = 'treelist.filterIsFalse';
/**
 * @hidden
 */
export var filterBooleanAll = 'treelist.filterBooleanAll';
/**
 * @hidden
 */
export var filterAfterOrEqualOperator = 'treelist.filterAfterOrEqualOperator';
/**
 * @hidden
 */
export var filterAfterOperator = 'treelist.filterAfterOperator';
/**
 * @hidden
 */
export var filterBeforeOperator = 'treelist.filterBeforeOperator';
/**
 * @hidden
 */
export var filterBeforeOrEqualOperator = 'treelist.filterBeforeOrEqualOperator';
/**
 * @hidden
 */
export var noRecords = 'treelist.noRecords';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[filterClearButton] = 'Clear',
    _a[filterEqOperator] = 'Is equal to',
    _a[filterNotEqOperator] = 'Is not equal to',
    _a[filterIsNullOperator] = 'Is null',
    _a[filterIsNotNullOperator] = 'Is not null',
    _a[filterIsEmptyOperator] = 'Is empty',
    _a[filterIsNotEmptyOperator] = 'Is not empty',
    _a[filterStartsWithOperator] = 'Starts with',
    _a[filterContainsOperator] = 'Contains',
    _a[filterNotContainsOperator] = 'Does not contain',
    _a[filterEndsWithOperator] = 'Ends with',
    _a[filterGteOperator] = 'Is greater than or equal to',
    _a[filterGtOperator] = 'Is greater than',
    _a[filterLteOperator] = 'Is less than or equal to',
    _a[filterLtOperator] = 'Is less than',
    _a[filterIsTrue] = 'Is true',
    _a[filterIsFalse] = 'Is false',
    _a[filterBooleanAll] = '(All)',
    _a[filterAfterOrEqualOperator] = 'Is after or equal to',
    _a[filterAfterOperator] = 'Is after',
    _a[filterBeforeOperator] = 'Is before',
    _a[filterBeforeOrEqualOperator] = 'Is before or equal to',
    _a[noRecords] = 'No records available',
    _a);
